

























































































































import { Vue, Component, Ref } from 'vue-property-decorator'
import { EventoDeWebhookDisponivel, FormWebhook } from '@/models'
import { arrayObrigatorio, obrigatorio } from '@/shareds/regras-de-form'
import { DocDeEvento, docDoEvento, montarEnvelopeDeExemploFormatado } from '@/shareds/exemplosDeWebhook'
import { FindWebhookUseCase, SaveWebhookUseCase, TestarWebhookUseCase } from '@/usecases'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import BlocoDeCodigo from './BlocoDeCodigo.vue'

@Component({
	components: { BlocoDeCodigo },
})
export default class DialogoDeEdicaoDeWebhook extends Vue {
	@Ref() form!: HTMLFormElement
	@Ref() campoDeUrl!: HTMLInputElement

	webhook: FormWebhook | null = null
	obrigatorio = obrigatorio
	arrayObrigatorio = arrayObrigatorio
	mostra = false
	criandoNovo = false
	salvando = false
	testando = false
	carregandoEventos = false
	abaDeExemplo = 0
	eventosDisponiveis: EventoDeWebhookDisponivel[] = []

	saveUseCase = new SaveWebhookUseCase()
	testarUseCase = new TestarWebhookUseCase()
	findUseCase = new FindWebhookUseCase()

	get eventosParaSelect() {
		return this.eventosDisponiveis.map(evento => ({
			text: evento.descricao,
			value: evento.chave,
		}))
	}

	urlValida(valor: string) {
		return /^https?:\/\/.+/.test(valor || '') || 'Informe uma URL http(s) válida'
	}

	get eventoDoExemploAtivo(): string | null {
		const eventos = (this.webhook && this.webhook.eventos) || []
		if (!eventos.length) return null
		const indice = this.abaDeExemplo >= 0 && this.abaDeExemplo < eventos.length ? this.abaDeExemplo : 0
		return eventos[indice]
	}

	get corpoDeExemplo(): string {
		return this.eventoDoExemploAtivo
			? montarEnvelopeDeExemploFormatado(this.eventoDoExemploAtivo)
			: ''
	}

	get docDoExemploAtivo(): DocDeEvento | null {
		return this.eventoDoExemploAtivo ? docDoEvento(this.eventoDoExemploAtivo) : null
	}

	async mostrar(webhook: FormWebhook, criandoNovo: boolean) {
		this.webhook = JSON.parse(JSON.stringify(webhook))
		this.criandoNovo = criandoNovo
		this.abaDeExemplo = 0
		this.mostra = true
		if (!this.eventosDisponiveis.length) {
			await this.carregarEventos()
		}
		setTimeout(() => {
			this.form.resetValidation()
			this.campoDeUrl.focus()
		})
	}

	esconder() {
		this.webhook = null
		this.mostra = false
	}

	async carregarEventos() {
		try {
			this.carregandoEventos = true
			this.eventosDisponiveis = await this.findUseCase.listarEventosDisponiveis()
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.carregandoEventos = false
		}
	}

	async salvar() {
		if (!this.webhook) return
		if (!this.form.validate()) return
		try {
			this.salvando = true
			const salvo = !this.webhook.id
				? await this.saveUseCase.create(this.webhook)
				: await this.saveUseCase.update(this.webhook)
			this.$emit('confirmado', salvo)
			AlertModule.setSuccess('Webhook salvo com sucesso')
			this.mostra = false
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
		}
	}

	async enviarTeste() {
		if (!this.webhook || !this.webhook.id) return
		try {
			this.testando = true
			await this.testarUseCase.testar(this.webhook.id)
			AlertModule.setSuccess('Evento de teste enviado')
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.testando = false
		}
	}

	copiarSecret() {
		if (!this.webhook || !this.webhook.secret) return
		navigator.clipboard.writeText(this.webhook.secret)
		AlertModule.setSuccess('Secret copiado')
	}
}
